export default __webpack_public_path__ + "static/media/loader_movr.849e6e9a.gif";